import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bdf1d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-search" }
const _hoisted_2 = { class: "setting flex-end" }

import { t } from '@/plugins/i18n'
import { ref, toRaw } from 'vue'
import { cloneDeep } from 'lodash'
import { clearForm, setDefaultForm } from '@/util/common'
import dblclick from '@/components/BatchSearch/index'
import { useRoute } from 'vue-router'
import { isMultiStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['form'],
  emits: ['update:form'],
  setup(__props, { emit: emits }) {

const props = __props


const route = useRoute()

const defaultForm = {
  keywordName: '',
  keywordSku: '',
  existWaitCombinationFlag: ''
}
const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)

const _form = ref(getForm(props.form))

const submit = () => {
  const form = cloneDeep(toRaw(_form.value))
  form.customerProductMskuList && (form.customerProductMskuList = form.customerProductMskuList.split('\n'))
  emits('update:form', form)
}
if (route.query?.existWaitCombinationFlag) {
  _form.value.existWaitCombinationFlag = Number(route.query?.existWaitCombinationFlag)
  const form = cloneDeep(toRaw(_form.value))
  emits('update:form', form)
}

const resetForm = () => {
  clearForm(_form.value)
  emits('update:form', cloneDeep(toRaw(_form.value)))
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['searchRef'] = _value
      },
      inline: true,
      model: _form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('客户商品sku')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.customerProductMskuList,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.customerProductMskuList) = $event)),
              onDblclick: _cache[1] || (_cache[1] = ($event: any) => {_form.value.customerProductMskuList='';_unref(dblclick)('customerProductMskuList')}),
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"220px"},
              maxlength: "100"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('商品名')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.keywordName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.keywordName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('组合商品SKU')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.keywordSku,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.keywordSku) = $event)),
              onDblclick: _cache[4] || (_cache[4] = ($event: any) => {_form.value.keywordSku='';_unref(dblclick)('keywordSkuList')}),
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"220px"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('组合在库状态')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _form.value.existWaitCombinationFlag,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.existWaitCombinationFlag) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _unref(t)('全部'),
                  value: ""
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(t)('存在待组合'),
                  value: 1
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(t)('不存在待组合'),
                  value: 0
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(isMultiStore)())
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _unref(t)('商品国家')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _form.value.goodsCountry,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_form.value.goodsCountry) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('全部'),
                      value: ""
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('中国'),
                      value: "CN"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('韩国'),
                      value: "KR"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "warning",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: resetForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})